import { render, staticRenderFns } from "./skyCheckboxCard.vue?vue&type=template&id=54d21ed4&scoped=true"
import script from "./skyCheckboxCard.vue?vue&type=script&lang=js"
export * from "./skyCheckboxCard.vue?vue&type=script&lang=js"
import style0 from "./skyCheckboxCard.vue?vue&type=style&index=0&id=54d21ed4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d21ed4",
  null
  
)

export default component.exports